// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_components__ToastView from "./ToastView.js";
import * as Buhta_core__Toast from "../../../core/lib/Toast.js";
import * as JsxRuntime from "react/jsx-runtime";

function ToastsList(Props) {
  const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  return JsxRuntime.jsx("div", {
    children: Belt__Belt_List.toArray(Belt__Belt_List.map(match[0], (function (toast) {
      const key = "toast-view-" + String(toast.id);
      return JsxRuntime.jsx(Buhta_components__ToastView.make, {
        toast: toast
      }, key);
    }))),
    className: "fixed top-0 w-screen flex flex-col items-center z-50 space-y-2 pt-2"
  });
}

const make = ToastsList;

export {
  make,
}
/* Buhta_components__ToastView Not a pure module */
